import { Component, OnInit, Inject,ViewChild, TemplateRef  } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material'; 
import { Subscription, interval } from 'rxjs';
import { LobbyService } from 'src/app/_services/lobby.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ConfirmboxComponent } from 'src/app/confirmbox/confirmbox.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-invite-friends',
  templateUrl: './invite-friends.component.html',
  styleUrls: ['./invite-friends.component.scss']
})
export class InviteFriendsComponent implements OnInit { 
  parameters:any; 
  deviceType ='';
  sub_joinLeagueIf: Subscription;
  sub_joinTournamentIf: Subscription;
  isMobile = false;
  assetURL: string;
  confirmDialogRef: MatDialogRef<ConfirmboxComponent>;
  @ViewChild('mobileApp') mobileApp: TemplateRef<any>;

  constructor(@Inject(MAT_DIALOG_DATA) private popupData,public dialog: MatDialog,
  private _lobbyService: LobbyService, 
  private dialogRef: MatDialogRef<InviteFriendsComponent>,
  private deviceService: DeviceDetectorService) {
  this.deviceType = this.deviceService.os;
  this.isMobile = this.deviceService.isMobile();
  this.parameters = popupData;

    this.sub_joinLeagueIf = this._lobbyService.updateLeagueMember().subscribe(state => {
      if(typeof state.entities.league_id !='undefined' && state.entities.league_id==this.parameters.fantasy_lg_id){
        let remEntrants =this.parameters.entrants - state.entities.draft_entries;
        this.parameters.body = `Your draft will begin when ${remEntrants} more joins`;
      }
    });
    this.sub_joinTournamentIf = this._lobbyService.updateTournamentMember().subscribe(state => {
      if(typeof state.entities.league_id !='undefined' && state.entities.league_id==this.parameters.fantasy_lg_id){
        let remEntrants =this.parameters.entrants - state.entities.draft_entries;
        if(remEntrants>1)
        this.parameters.body = `Your draft will begin when ${remEntrants} more join`;
        else
        this.parameters.body = `Your draft will begin when ${remEntrants} more joins`;
      }
    });
  }

  ngOnInit() { 
    this.assetURL = `${environment.assetURL}`;
  }

  ngOnDestroy() {
    if (this.sub_joinLeagueIf) { this.sub_joinLeagueIf.unsubscribe(); }
    if (this.sub_joinTournamentIf) { this.sub_joinTournamentIf.unsubscribe(); }
  }
  closePopup(){
    this.dialogRef.close(1);
  }

  redirectUrl(url){
    window.location.href = url;
  } 

  openAppPopup() {
    this.confirmDialogRef = this.dialog.open(this.mobileApp, {
      width: this.isMobile?'90%':'50%',
      data: { }
    });
    
    this.confirmDialogRef.afterClosed()
    .subscribe(res => {})
  }
}
